import { CompassIcon, TypeIcon, PuzzleIcon, TargetIcon } from 'lucide-react';

export const aiQuestions = [
  'What should I ask?',
  'How should I structure the prompt?',
  'What information should I give it?',
  'How do I make the output sound professional?',
  'How do I turn this into something I can actually use?',
];

export const painPoints = [
  {
    icon: CompassIcon,
    title: 'You don’t know what to ask AI',
    desc: 'You open ChatGPT with a real estate task in front of you — and end up staring at a blank conversation. THE REALTOR AI PLAYBOOK™ gives you ready-to-adapt prompts organized by the exact workflow you’re working on.',
  },
  {
    icon: TypeIcon,
    title: 'Your AI responses feel too generic',
    desc: 'Generic prompts produce generic results. The system gives you structured instructions, context fields and professional constraints designed specifically for real estate workflows.',
  },
  {
    icon: PuzzleIcon,
    title: 'You waste time reinventing the same prompts',
    desc: 'Listing descriptions. Follow-ups. Lead responses. Content. Objections. Instead of rebuilding the instruction every time, start from a specialized framework and customize it to your situation.',
  },
  {
    icon: TargetIcon,
    title: 'You want AI to actually save you time',
    desc: 'The goal isn’t to become an AI expert. It’s to have a practical system you can open whenever you need help with a real estate task.',
  },
];
